import * as React from "react";
import {RouteComponentProps, Link} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ILoanApplicationInfo, IUserStatus} from "StateInterface";
import {ApplicationStatus} from "profile/enums";
import "./style.scss";
import StatusCard from "Dashboard/components/statusCard";
import Card from "myshubhlife-component/card";
import {imageBaseUrl, websiteUrl} from "config";
import {useEffect, useState} from "react";
import {getProfile} from "profile/api";
import {setProfileInfo} from "profile/actions";
import Loading from "components/loading";
import {history} from "load/store";
import {statusMessages} from "Dashboard/utils";
import {LoginMode} from "login/reducer";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    userId: number;
    userStatus: IUserStatus;
    loanApplicationInfo: ILoanApplicationInfo;
    utm_source?: string;
    authExt?: {[key: string]: string};
    loginMode: LoginMode;
    isPartnerAndroid: boolean;
}

export enum RedirectPath {
    Dashboard = "dashboard",
    Loans = "loans"
}

const Dashboard = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState(false);
    const fetchProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfile(props.userId);
            if (response.status === 200) {
                setLoading(false);
                props.dispatch(setProfileInfo(response.data));
            }
        } catch(err) {
            setLoading(false);
        }
    };
    const getAllQueryParams = (authExt) => {
        let allQuery;
        if (authExt && Object.keys(authExt).length) {
            allQuery = Object.keys(authExt)
            .map((key) => `${key}=${authExt[key]}`)
            .join("&");
        }
        return allQuery;
    };
    const redirectToPath = (redirectPath: RedirectPath, params?: string) => {
        const searchParam = params ? `?${params}` : "";
        window.location.replace(`${websiteUrl}/${redirectPath}/#/${searchParam}`);
    };
    useEffect(() => {
        if (!props.isAndroid) {
            localStorage.setItem("loginMode", props.loginMode);
            
            const isSsoLogin = props.loginMode === LoginMode.SSO;
            const isLoginV2 = props.loginMode === LoginMode.V2;

            if (props.authExt?.["redirect"] === RedirectPath.Loans || isSsoLogin) {
                redirectToPath(RedirectPath.Loans, getAllQueryParams(props.authExt));
                return;
            }

            if (!props?.authExt?.accessToken || isLoginV2) {
                redirectToPath(RedirectPath.Dashboard, getAllQueryParams(props.authExt));
                return;
            }
        }
        fetchProfile();
    }, []);
    const handleClick = () => {
        history.push("/incomplete-info");
    }
    return (
        <>
            <Loading active={loading} msg={"Please wait, we're fetching your details"}/>
            {
                props.loanApplicationInfo && props.loanApplicationInfo.status === ApplicationStatus.INCOMPLETE_INFO ?
                    <StatusCard
                        status={statusMessages[props.loanApplicationInfo.status]}
                        onClick={handleClick}
                    /> :
                    <div>
                        {!props.isPartnerAndroid && <Link to="/loan-application">
                            <Card>
                                <div className="apply-now-button-container">
                                    <div className="serviceable-text">We are serviceable now</div>
                                    <div className="apply-now-button">
                                        <div>
                                            <div className={`apply ${props.utm_source && props.utm_source.toLocaleLowerCase()}-text-color`}>Apply Loan</div>
                                            <div className="click-to-complete">Click to complete loan application.</div>
                                        </div>
                                        <div className="arrow-icon">
                                            <img src={`${imageBaseUrl}/img/right-arrow-icon.png`} alt="arrow icon" />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Link>}
                        <Link to="/loans">
                            <Card>
                                <div className="apply-now-button-container">
                                    <div className="apply-now-button">
                                        <div>
                                            <div className={`apply ${props.utm_source && props.utm_source.toLocaleLowerCase()}-text-color`}>My Loans</div>
                                            <div className="click-to-complete">Click to check disbursed loans.</div>
                                        </div>
                                        <div className="arrow-icon">
                                            <img src={`${imageBaseUrl}/img/right-arrow-icon.png`} alt="arrow icon" />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Link>
                    </div>
            }
        </>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        userStatus: state.profileInfo.userStatus,
        loanApplicationInfo: state.profileInfo.userStatus ? state.profileInfo.userStatus.latestApplicationsStatus.loanApplicationInfo : null,
        utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
        authExt: state.login.authExt ? state.login.authExt : null,
        loginMode: state.login.loginMode,
        isPartnerAndroid: state.login.isPartnerAndroid,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Dashboard);
